import glamorous from 'glamorous';
import themes from '../../themes'


export default glamorous.nav(
    { 
        position: "fixed",
        zIndex: 0,
        minWidth: "80px",
        height: "100vh",
        textAlign: "center",
        fontFamily: "Helvetica",
        fontSize: "24px",
        top:"0px",
        left: "0px",
    },
         props => {
            switch (props.theme) {
            case "dark": {
                return {backgroundColor: themes[0].color1}
                
            }
            case "light": {
                return {backgroundColor: themes[1].color1}
            }
        }
    }
);



// WEBPACK FOOTER //
// ./src/containers/nav/NavStyled.js